import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <UpdatesSection />
        <CommentsSection />
        <CarouselSection />
        <AppSection />
        <FaqSection />
        <MediaSection />
        <IndexSection />
        <FeaturesSection />
        <AboutSection />
        <TopicsSection />
        <RankingSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}